import { TEMPLATE_CATEGORIES } from '@shared/constants';

// Stored categories are authoritative; name/type fallback is only for legacy rows.
export function isMeetingTemplate(value: unknown): boolean {
  if (!value || typeof value !== 'object') return false;
  const template = value as Record<string, unknown>;
  if (typeof template.category === 'string' && template.category.trim()) {
    return template.category === TEMPLATE_CATEGORIES.MEETING;
  }
  const name = typeof template.name === 'string' ? template.name.toLowerCase() : '';
  return ['meeting', 'agenda', 'level', 'quarterly', 'huddle', 'clarity'].some(word => name.includes(word)) ||
    ['Level10', 'Quarterly', 'DailyHuddle', 'ClarityBreak', 'RoleBased'].includes(String(template.type ?? ''));
}
